import { useGoalPresence } from '../hooks/useGoalPresence.js'
import { useUIStore } from '../store/uiStore.js'
import { colorFor } from '../data/userColors.js'

/**
 * EditingPresence — small row of avatars for users currently editing this
 * goal (via Ably per-goal presence).
 *
 * Powered by useGoalPresence. Renders nothing when no one else is editing.
 * This user's own editing doesn't appear (they know they're editing).
 */
export default function EditingPresence({ pillarName, goalIndex }) {
  const editingGoalKey = useUIStore((s) => s.editingGoalKey)
  const thisKey = `${pillarName}:${goalIndex}`
  const actAsEditor = editingGoalKey === thisKey

  const editors = useGoalPresence({ pillarName, goalIndex, actAsEditor })

  if (editors.length === 0) return null

  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        marginLeft: 8,
      }}
      title={`Currently editing: ${editors.map((e) => e.name).join(', ')}`}
    >
      {editors.slice(0, 3).map((e) => {
        const c = colorFor(e.name)
        return (
          <span
            key={e.name}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 20,
              height: 20,
              borderRadius: '50%',
              background: c,
              color: '#fff',
              fontSize: 10,
              fontWeight: 800,
              border: '2px solid #fff',
              boxShadow: `0 0 0 1.5px ${c}40`,
              animation: 'pulseEdit 1.4s ease-in-out infinite',
            }}
          >
            {e.name[0]}
          </span>
        )
      })}
      {editors.length > 3 && (
        <span style={{ fontSize: 10, color: 'var(--muted)', marginLeft: 2 }}>
          +{editors.length - 3}
        </span>
      )}
      <span
        style={{
          fontSize: 10,
          fontWeight: 600,
          color: 'var(--muted)',
          marginLeft: 2,
          fontStyle: 'italic',
        }}
      >
        {editors.length === 1 ? 'editing…' : 'editing…'}
      </span>
    </div>
  )
}
